<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>任务管理</a-breadcrumb-item>
    <a-breadcrumb-item>短剧库</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <!-- 剧名 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">剧名：</a-col>
          <a-col :span="18">
            <a-input
              class="tool-item"
              v-model:value="dramaNameModel"
              placeholder="请输入"
            />
          </a-col>
        </a-row>
      </a-col>
      <!-- 频道 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">频道：</a-col>
          <a-col :span="18">
            <a-select
              class="tool-item"
              v-model:value="channelModel"
              placeholder="请选择"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="item in DramaChannelTypes" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 题材 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">题材：</a-col>
          <a-col :span="18">
            <a-select
              show-search
              class="tool-item"
              v-model:value="themeModel"
              placeholder="请选择"
              :filter-option="filterOption"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="item in themes" :key="`${item.id} - ${item.name}`" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 素材 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">素材：</a-col>
          <a-col :span="18">
            <a-select
              show-search
              class="tool-item"
              v-model:value="materialModel"
              placeholder="请选择"
              :filter-option="filterOption"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option :value="1">有</a-select-option>
              <a-select-option :value="2">无</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 状态 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">状态：</a-col>
          <a-col :span="18">
            <a-select
              class="tool-item"
              v-model:value="stateModel"
              placeholder="请选择"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="item in OnShelfTypes" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 操作 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px; margin-right: 16px;" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table
    :data-source="dataSource"
    :columns="columns"
    :pagination="pagination"
    :row-key="record => record.id"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 频道 -->
      <template v-if="column.key === 'playlet_gender'">
        {{ DramaChannelTypes
          .filter(channel => (record.playlet_gender || []).includes(channel.value))
          .map(channel => channel.text)
          .join('、') || '-'
        }}
      </template>
      <!-- 前台状态 -->
      <template v-else-if="column.key === 'status'">
        {{ (OnShelfTypes.find(item => item.value === record[column.key]) || {}).text || '-' }}
      </template>
      <!-- 操作 -->
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="add(record)">编辑</a>
      </template>
      <template v-else>
        {{ record[column.key] || '-' }}
      </template>
    </template>
  </a-table>
  <!-- 新增、编辑弹窗 -->
  <Add ref="RefAdd" @success="getList" />
</template>

<script setup>
import { ref, reactive, nextTick, onBeforeMount } from 'vue'
import { message } from 'ant-design-vue'
import { OnShelfTypes, DramaChannelTypes } from '@/utils/constantList'
import Add from './components-drama-library/Add.vue'
import { dramaList, classifySelectList } from '@/api/request'

// 单个子组件暴露体初始化
let RefAdd = ref(null)
// 剧名
let dramaName = ref(undefined)
let dramaNameModel = ref(undefined)
// 频道
let channel = ref(undefined) 
let channelModel = ref(undefined) 
// 题材
let theme = ref(undefined) 
let themeModel = ref(undefined) 
let themes = ref([])
// 素材
let material = ref(undefined) 
let materialModel = ref(undefined)
// 状态
let state = ref(undefined)
let stateModel = ref(undefined)
// 排序字段
let order = ref(undefined)
let orderType = ref(undefined)
// 数据源
let dataSource = ref(null)
// 加载
let isLoading = ref(false)
// 表头
let columns = reactive([
  {
    title: '短剧ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '短剧名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '频道',
    dataIndex: 'playlet_gender',
    key: 'playlet_gender',
  },
  {
    title: '集数',
    dataIndex: 'total_ep',
    key: 'total_ep',
  },
  {
    title: '评级',
    dataIndex: 'grade',
    key: 'grade',
  },
  {
    title: '进行中任务数',
    dataIndex: 'task_count',
    key: 'task_count',
  },
  {
    title: '投稿数',
    dataIndex: 'tougao_count',
    key: 'tougao_count',
  },
  {
    title: '昨日佣金',
    dataIndex: 'yesterday_money',
    key: 'yesterday_money',
    sorter: true,
  },
  {
    title: '累计佣金',
    dataIndex: 'total_money',
    key: 'total_money',
    sorter: true,
  },
  {
    title: '每稿分佣',
    dataIndex: 'average_money',
    key: 'average_money',
    sorter: true,
  },
  {
    title: '入库天数',
    dataIndex: 'days',
    key: 'days',
  },
  {
    title: '前台状态',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: '总权重',
    dataIndex: 'weight',
    key: 'weight',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])
// 分页
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  // 初始化选择项列表
  getSelectList()
  // 获取列表
  getList()
})

// 初始化选择项列表
function getSelectList () {
  classifySelectList({source: 'theme'}).then(res => {
    const { code, data } = res
    if (code === 0) {
      themes.value = data
    }
  })
}


// 子组件新增弹窗
function add (record) {
  RefAdd.value.showDrawer(record)
}

// 查询
function touchSearch () {
  // 调整参数
  dramaName.value = dramaNameModel.value
  channel.value = channelModel.value
  theme.value = themeModel.value
  material.value = materialModel.value
  state.value = stateModel.value
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function touchReset () {
  dramaName.value = undefined
  dramaNameModel.value = undefined
  channel.value = undefined
  channelModel.value = undefined
  theme.value = undefined
  themeModel.value = undefined
  material.value = undefined
  materialModel.value = undefined
  state.value = undefined
  stateModel.value = undefined
  order.value = undefined
  orderType.value = undefined
  // 初始化获取
  touchSearch()
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 表格change
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  if (sorter.columnKey) {
    order.value = sorter.columnKey
    orderType.value = sorter.order === 'descend' ? 'desc' : 'asc'
  }
  getList()
}

// 获取列表
function getList () {
  isLoading.value = true
  const params = {
    name: dramaName.value,
    playlet_gender: channel.value,
    theme: theme.value,
    is_cloud_link: material.value,
    status: state.value,
    order: order.value,
    order_type: orderType.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  dramaList(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      const list = data.data
      list.forEach(item => {
        item.theme_ids = item.themes.map(theme => {
          return theme.id
        })
        item.tag_ids = item.tags.map(tag => {
          return tag.id
        })
      })
      dataSource.value = list
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  }).catch(() => {
    isLoading.value = false
  })
}
</script>

<style scoped>
.tool-view {
  width: 100%;
  display: flex;
  align-items: center;
}
.table-view {
  margin-top: 30px;
}
.tool-title:not(:first-child) {
  margin-left: 16px;
}

</style>